import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCNLocale from "./zh_CN";
import enUSLocale from "./en_US";
// import hiINLocale from './hi_IN'
// import inIDLocale from './in_ID'
// import thTHLocale from './th_TH'
// import viVNLocale from './vi_VN'
// import ptBRLocale from './pt_BR'
// import ptITLocale from './it_IT'

import { Locale } from "vant";
import vzhCNLocale from "vant/es/locale/lang/zh-CN";
import venUSLocale from "vant/es/locale/lang/en-US";
// import vhiINLocale from './vant/hi_IN'
// import vinIDLocale from './vant/in_ID'
// import vthTHLocale from './vant/th_TH'
// import vviVNLocale from './vant/vi_VN'
// import vptBRLocale from './vant/pt_BR'
// import vptITLocale from './vant/it_IT'

import mzhCNLocale from "./mint/zh_CN";
import menUSLocale from "./mint/en_US";
// import mhiINLocale from './mint/hi_IN'
// import minIDLocale from './mint/in_ID'
// import mthTHLocale from './mint/th_TH'
// import mviVNLocale from './mint/vi_VN'
// import mptBRLocale from './mint/pt_BR'
// import mptITLocale from './mint/it_IT'

import Config from "@/config";

Vue.use(VueI18n);
Vue.locale = () => {};

const messages = {
  en_US: {
    ...Object.assign(venUSLocale, menUSLocale),
    ...enUSLocale
  },
  zh_CN: {
    ...Object.assign(vzhCNLocale, mzhCNLocale),
    ...zhCNLocale
  }
  // hi_IN: {
  //   ...Object.assign(vhiINLocale, mhiINLocale),
  //   // ...hiINLocale,
  // },
  // in_ID: {
  //   ...Object.assign(vinIDLocale, minIDLocale),
  //   // ...inIDLocale,
  // },
  // th_TH: {
  //   ...Object.assign(vthTHLocale, mthTHLocale),
  //   // ...thTHLocale,
  // },
  // vi_VN: {
  //   ...Object.assign(vviVNLocale, mviVNLocale),
  //   // ...viVNLocale,
  // },
  // pt_BR: {
  //   ...Object.assign(vptBRLocale, mptBRLocale),
  //   // ...ptBRLocale,
  // },
  // it_IT: {
  //   ...Object.assign(vptITLocale, mptITLocale),
  //   // ...ptITLocale,
  // },
};

function getChineseKey() {
  return "zh_CN";
}

function getLocalLanguage() {
  let localLanguage = null;
  try {
    const language = localStorage.getItem("language");
    if (language) {
      localLanguage = JSON.parse(language);
    } else {
      localLanguage = { name: "中文", code: "zh_CN" };
    }
  } catch (e) {
    console.log("getLocalLanguage parse error!");
  }
  return localLanguage;
}
export function getLocalApiCoin() {
  let localApiCoin = null;
  try {
    const apiCoin = localStorage.getItem("api-coin");
    if (apiCoin) {
      localApiCoin = JSON.parse(apiCoin);
    }
  } catch (e) {
    console.log("getLocalApiCoin parse error!");
  }
  return localApiCoin;
}

function getLanguage() {
  const localLanguage = getLocalLanguage();
  if (localLanguage) return localLanguage.code;

  // if has not choose language
  // const language = (
  //   window.configText.language || navigator.language || navigator.browserLanguage
  // ).toLowerCase();
  const language = configText.language || "";
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }

  return Config.language;
}

export function checkChineseKey() {
  return getChineseKey() === getLanguage();
}

const loadedLanguages = [];

export function loadLanguageAsync(lang) {
  if (!loadedLanguages.includes(lang)) {
    return import(`./${lang}.js`).then(msgs => {
      i18n.setLocaleMessage(lang, {
        ...messages[lang],
        ...msgs.default
      });
      loadedLanguages.push(lang);
      return lang;
    });
  }
  return Promise.resolve(lang);
}

const i18n = new VueI18n({
  locale: getLanguage(),
  silentTranslationWarn: true,
  messages
});

function vantLocales(lang) {
  Locale.use(lang, messages[lang]);
}

vantLocales(i18n.locale);

export { i18n, vantLocales, getLanguage, getChineseKey, getLocalLanguage };
